import SettingsTypes from './settings.types';
import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Api from '../../utils/Api';
import { clearLocalStorage } from '../../utils/commonFunctions';
import UtilsTypes from '../utilities/utils.types';
import Loader from '../../utils/Loader';
import { getNotifyStatus, getSpeechStatus } from './settings.selectors';
import $ from 'jquery';

function* setError(msg) {
	if (msg === 'Token is Invalid' || msg === 'Token is missing') {
		clearLocalStorage();
		yield put(push('/'));
	} else {
		yield put({ type: UtilsTypes.SET_ERROR_MSG, payload: msg });
	}
	Loader.hide();
}

function* setErrorPanel(panelMsg, panelClass = 'alert alert-danger') {
	let errorPanel = {
		panelMsg,
		panelClass,
	};
	yield put({ type: UtilsTypes.SET_ERROR_PANEL, payload: errorPanel });

	Loader.hide();
}

function* fetchLicense() {
	try {
		const res = yield call(Api, {
			url: 'licenses',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				const { organisationID, organisation_name, keys } = res.data;
				let payload = {
					organisationID: organisationID,
					organisationName: organisation_name,
					licenseKey: keys[0].key,
				};
				yield put({ type: SettingsTypes.FETCH_LICENSE.SUCCESS, payload });
			} else if (res.code !== 204) {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('settings', err);
	}
}

function* fetchCertificates() {
	try {
		const res = yield call(Api, {
			url: 'listcertificates',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({
					type: SettingsTypes.FETCH_CERTIFICATES.SUCCESS,
					payload: res.data,
				});
			} else if (res.code !== 204) {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('settings', err);
	}
}

function* fetchOrders() {
	try {
		const res = yield call(Api, {
			url: 'orders',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				let payload = {
					orders: res.data,
					orderErrMsg: res.message,
				};
				yield put({ type: SettingsTypes.FETCH_ORDERS.SUCCESS, payload });
			} else if (res.code !== 204) {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('settings', err);
	}
}

function* checkSpeech() {
	try {
		const res = yield call(Api, {
			url: 'checkspeech',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				const { speech_is_on } = res.data;
				let payload = {};
				if (speech_is_on) {
					payload = {
						speechOn: { checked: 'checked' },
						speechIsOn: true,
					};
				} else {
					let speechModal = {};
					speechModal['data-toggle'] = 'modal';
					speechModal['data-target'] = '#mictest-popup';
					payload = { speechModal };
				}
				yield put({ type: SettingsTypes.FETCH_CHECK_SPEECH.SUCCESS, payload });
			} else if (res.code !== 204) {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('settings', err);
	}
}

function* updateLicenseKey({ payload }) {
	//allocateLicense
	document.getElementById('sk-circle').style.display = 'block';
	document.documentElement.style.overflow = 'hidden';
	document.getElementById('myDiv').style.opacity = 0.3;
	try {
		const res = yield call(Api, {
			url: 'licenses',
			method: 'POST',
			data: {
				license_key: payload,
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (res.status !== 'success') {
			yield call(setErrorPanel, res);
		} else {
			yield call(setErrorPanel, {
				panelMsg: res.message,
				panelClass: 'alert alert-success',
			});
		}
		Loader.hide();
		//this.setState({ success: true });
		//window.location.reload();
		document.getElementById('sk-circle').style.display = 'none';
		document.documentElement.style.overflow = 'auto';
		document.getElementById('myDiv').style.opacity = 1;
	} catch (err) {
		console.log('settings', err);
	}
}

function* toggleMicStatus() {
	let speechStatus = yield select(getSpeechStatus);
	try {
		const res = yield call(Api, {
			url: 'checkspeech',
			method: 'POST',
			data: {
				speech_is_on: !speechStatus,
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.status !== 'success') {
				yield call(setErrorPanel, res.message);
			} else {
				Loader.hide();
				yield put({
					type: SettingsTypes.DISABLE_MIC.SUCCESS,
					payload: !speechStatus,
				});
				window.location.reload();
			}
			window.location.reload();
			Loader.hide();
		}
	} catch (err) {
		console.log('settings', err);
	}
}

function* toggleNotification() {
	let notifyStatus = yield select(getNotifyStatus);
	Loader.show();

	try {
		const res = yield call(Api, {
			url: 'checknotify',
			method: 'POST',
			data: {
				notify_is_on: !notifyStatus,
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setErrorPanel, res);
			yield put({
				type: SettingsTypes.UPDATE_NOTIFICATION_STATUS,
				payload: !notifyStatus,
			});
		} else {
			Loader.hide();
			window.location.reload();
		}
	} catch (err) {
		console.log('settings', err);
	}
}

function* checkNotify() {
	try {
		const res = yield call(Api, {
			url: 'checknotify',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setErrorPanel, res);
		} else {
			Loader.hide();
			let payload = {};
			if (res.data.notify_is_on === true) {
				payload = {
					isNotify: { checked: 'checked' },
					notificationIsOn: 1,
					notificationText:
						'You are currently subscribed to receive course related progress and updates.',
				};
			} else {
				payload = {
					notificationIsOn: 0,
					notificationText:
						'Turn on Notifications to receive course related progress and updates.',
				};
			}

			yield put({ type: SettingsTypes.CHECK_NOTIFICATION.SUCCESS, payload });
			Loader.hide();
		}
	} catch (err) {
		console.log('settings', err);
	}
}

function* sendOTP() {
	try {
		const res = yield call(Api, {
			url: 'sendotp',
			method: 'POST',
			data: {
				user_name: $('#MergeID').val(),
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			Loader.hide();

			if (res.status !== 'success') {
				yield call(setError, res.message);
			} else {
				if (res.code === 200) {
					// Success
					$('#mergeSuccess').html(
						res.message + '. Enter pin received to complete merging of accounts',
					);
					$('#mergeSuccess').show();
					$('#mergeUserId').val(res.data.id);
					$('#MergeOTPSection').show();
					$('#MergeButton').show();
					$('#MergeOTPButton').hide();
				} else {
					$('#mergeError').html(res.message);
					$('#mergeError').show();
				}
			}
		}
	} catch (err) {
		console.log('settings', err);
	}
}

function* mergeUser() {
	try {
		const res = yield call(Api, {
			url: 'mergeuser',
			method: 'POST',
			data: {
				secondary_id: $('#mergeUserId').val(),
				OTP: $('#MergeOTP').val(),
			},
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			Loader.hide();
			if (res.status !== 'success') {
				yield call(setError, res.message);
			} else {
				if (res.code === 200) {
					// Success
					$('#mergeSuccess').html(res.message);
					$('#mergeSuccess').show();
					// setTimeout
					setTimeout(function () {
						window.location.reload();
					}, 3000);
				} else {
					$('#mergeError').html(res.message);
					$('#mergeError').show();
				}
			}
		}
	} catch (err) {
		console.log('settings', err);
	}
}

function* mergeUserStart() {
	yield takeLatest(SettingsTypes.MERGE_ACCOUNT.PENDING, mergeUser);
}

function* sendOTPStart() {
	yield takeLatest(SettingsTypes.SEND_OTP.PENDING, sendOTP);
}

function* fetchLicenseStart() {
	yield takeLatest(SettingsTypes.FETCH_LICENSE.PENDING, fetchLicense);
}

function* fetchCertificatesStart() {
	yield takeLatest(SettingsTypes.FETCH_CERTIFICATES.PENDING, fetchCertificates);
}

function* fetchOrdersStart() {
	yield takeLatest(SettingsTypes.FETCH_ORDERS.PENDING, fetchOrders);
}

function* checkSpeechStart() {
	yield takeLatest(SettingsTypes.FETCH_CHECK_SPEECH.PENDING, checkSpeech);
}

function* updateLicenseKeyStart() {
	yield takeLatest(SettingsTypes.UPDATE_LICENSE.PENDING, updateLicenseKey);
}

function* toggleMicStatusStart() {
	yield takeLatest(SettingsTypes.DISABLE_MIC.PENDING, toggleMicStatus);
}

function* checkNotifyStart() {
	yield takeLatest(SettingsTypes.CHECK_NOTIFICATION.PENDING, checkNotify);
}

function* toggleNotificationStart() {
	yield takeLatest(
		SettingsTypes.TOGGLE_NOTIFICATIONS.PENDING,
		toggleNotification,
	);
}

export function* settingsSagas() {
	yield all([
		call(fetchLicenseStart),
		call(updateLicenseKeyStart),
		call(toggleMicStatusStart),
		call(checkNotifyStart),
		call(toggleNotificationStart),
		call(fetchCertificatesStart),
		call(fetchOrdersStart),
		call(checkSpeechStart),
		call(mergeUserStart),
		call(sendOTPStart),
	]);
}
